export default "__VITE_ASSET__CryKO_Io__"